import React from "react";

export default function Switch({ checked, onChange }) {
	return (
		<button
			type="button"
			onClick={onChange}
			className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 focus:outline-none
        ${checked ? "bg-green-500" : "bg-gray-200"}
      `}
			aria-pressed={checked}
		>
			<span
				className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform duration-200
          ${checked ? "translate-x-5" : "translate-x-1"}
        `}
			/>
		</button>
	);
}
